export var EXTERNAL_PASSPORT_APP_DOMAIN_NAME = "carrierlogistics";

//# sourceMappingURL=externalSiteConstants.js.map